// src/context/OutletStore.ts
var fallbackOutletCounter = 0;
var OutletStore = class {
  constructor() {
    this.#entries = /* @__PURE__ */ new Map();
    this.#snapshot = { entries: this.#entries, version: 0 };
    this.#listeners = /* @__PURE__ */ new Set();
    this.subscribe = (listener) => {
      this.#listeners.add(listener);
      return () => {
        this.#listeners.delete(listener);
      };
    };
    this.getSnapshot = () => this.#snapshot;
  }
  #entries;
  #snapshot;
  #listeners;
  /** Re-renders every outlet. Called when a host render prop changed identity. */
  invalidate() {
    this.#publish();
  }
  mount(el, render, args) {
    const id = el.dataset.novuOutlet ?? `nv-host-outlet-${fallbackOutletCounter++}`;
    this.#set({ id, el, render, args });
    return {
      update: (...nextArgs) => {
        const current = this.#entries.get(id);
        if (!current) {
          return;
        }
        this.#set({ ...current, args: nextArgs });
      },
      unmount: () => {
        if (!this.#entries.has(id)) {
          return;
        }
        const next = new Map(this.#entries);
        next.delete(id);
        this.#entries = next;
        this.#publish();
      }
    };
  }
  #set(entry) {
    const next = new Map(this.#entries);
    next.set(entry.id, entry);
    this.#entries = next;
    this.#publish();
  }
  #publish() {
    this.#snapshot = { entries: this.#entries, version: this.#snapshot.version + 1 };
    for (const listener of this.#listeners) {
      listener();
    }
  }
};
export {
  OutletStore
};
//# sourceMappingURL=OutletStore.js.map